import { useTranslation } from 'react-i18next';

import { formatTrimmedDecimal } from '@/helpers/finance';

const PERCENT_DECIMAL_PLACES = 1;

export interface SummaryFormatters {
  /** "160h" — the hours unit is i18n copy, not a hardcoded suffix. */
  formatHoursAmount: (hours: number) => string;
  /** "78.4%" */
  formatPct: (pct: number) => string;
  /** "+8h" / "−8h" / "0h" — the sign is what makes a divergence readable at a glance. */
  formatSignedHours: (hours: number) => string;
}

/**
 * The number formatting every approvals summary card shares. Extracted so the four cards
 * render identical units without each re-deriving them (and drifting apart).
 */
export const useSummaryFormat = (): SummaryFormatters => {
  const { t } = useTranslation('authenticated.timeTracking');

  const formatHoursAmount = (hours: number) =>
    t('approvals.summaryCards.trackedVsBooked.hours', { hours: formatTrimmedDecimal(hours, 2) });

  return {
    formatHoursAmount,
    formatPct: pct => `${formatTrimmedDecimal(pct, PERCENT_DECIMAL_PLACES)}%`,
    formatSignedHours: hours =>
      hours === 0
        ? formatHoursAmount(0)
        : `${hours > 0 ? '+' : '−'}${formatHoursAmount(Math.abs(hours))}`,
  };
};
